import React from "react";
import Stack from "@mui/material/Stack";
import { useQuery } from "@tanstack/react-query";
import { getEmomDetails } from "../../api/workouts";
import EmomExerciseChart from "./EmomExerciseChart";
import Loader from "../Display/Loader";

const ExerciseFailedChart = ({ workoutId }) => {
  const { data, isPending } = useQuery({
    queryKey: ["workout", workoutId, "emom", "details"],
    queryFn: ({ signal }) => getEmomDetails({ workoutId, signal }),
  });
  return (
    <Stack height={"100%"}>
      {!isPending ? (
        <EmomExerciseChart data={data.fail} type={"fail"} />
      ) : (
        <Loader height={"100%"} />
      )}
    </Stack>
  );
};

export default ExerciseFailedChart;
